import cookies from "./cookies"
import * as urlHandler from "./url"
import * as request from "./request"
import * as helper from "./helper"

/**
 * 微信相关
 * @param {String} opt.appid 业务的offerid
 * @param {String} opt.context 授权会带过去
 * @param {Boolean} opt.forceOAuth 每次都强制跳授权。默认是false
 * @param {String} opt.openid 用户的openid
 * @param {String} opt.accessToken 用户的accessToken
 * @param {String} opt.scope 权限scope=snsapi_base,snsapi_userinfo
 * @param {Int} opt.getDetail 1为获取用户信息
 */
var wechat = function (opt) {
  opt = opt || {}

  /**
   * 公众号的appid
   */
  this.appid = opt.appid || wechat.defaultAppid

  /*
    商户号
   */
  this.mchid = opt.mchid || wechat.defaultMchid

  /**
   * 上下文，授权会带过去
   */
  this.context = opt.context || +new Date()

  /**
   * 每次都强制跳授权。默认是false
   */
  this.forceOAuth = ~~opt.forceOAuth

  /**
   * 用户的openid
   */
  this.openid = opt.openid || null

  //微信的scope权限scope=snsapi_base,snsapi_userinfo
  this.scope = opt.scope || "pay_realname"

  /**
   * 用户的accessToken
   */
  this.accessToken = opt.accessToken || null

  /**
   * 授权返回的code
   */
  this.code = urlHandler.getParam("code")

  /**
   * refresh_token存储在cookie里的key
   */
  this.refreshTokenKey = this.appid + "realname_rt"

  /**
   * 1为获取用户信息
   */
  this.getDetail = opt.getDetail || ""

  if (this.getDetail == 1) {
    this.scope = "snsapi_userinfo"
  }

  var _t

  if ((_t = opt.code) || ((_t = urlHandler.getParam("code")) && this.context == urlHandler.getParam("state"))) {
    //如果url中有code，就标记为CODE
    this._code = _t
    this.type = TYPE.CODE
  } else if (~~opt.forceOAuth) {
    //如果强制授权的，就需要授权NEED_OAUTH
    this.type = TYPE.NEED_OAUTH
  } else if (cookies.get(this.refreshTokenKey)) {
    //如果cookie中有refresht_token就标记为MY_REFRESH_TOKEN
    this._refresh_token = cookies.get(this.refreshTokenKey)
    this.type = TYPE.MY_REFRESH_TOKEN
  } else {
    //其他标记为NEED_OAUTH
    this.type = TYPE.NEED_OAUTH
  }
}

wechat.defaultAppid = "wx951bdcac522929b6"
wechat.defaultMchid = "1524624411"
//授权的模式
var TYPE = (wechat.TYPE = {
  //跳授权取code的模式
  CODE: 1,

  //自己种的refresh_token
  MY_REFRESH_TOKEN: 2,

  //需要跳授权
  NEED_OAUTH: 4
})
wechat.prototype = {
  /**
   * init后就能调用getOpenid取用户的openid了
   * @param {Function} opt.onSuccess 能取到code或者refresh_token的成功回调
   * @param {Function} opt.onBeforeOAuth 如果取不到code或者refresh_token就会去跳授权。return false可以阻止跳授权
   * @param {String} opt.isNotInWechat 微信场景获取授权还是移动浏览器场景获取授权
   * @param {String} opt.redirectUrl 指定授权回调地址
   */
  init: function (opt) {
    opt = opt || {}
    //先判断能否取用户的openid信息
    if (this.type === TYPE.NEED_OAUTH) {
      if (!opt.onBeforeOAuth || opt.onBeforeOAuth.call(this) === true) {
        this.oAuth(opt)
      }
      return false
    } else {
      opt.onSuccess && opt.onSuccess.call(this)
      return true
    }
  },
  /**
   * 获取实名认证信息
   * @param {Function} opt.onSuccess 成功回调
   * @param {Function} opt.onExpire code或者refresh_token过期了。默认会去跳授权。return false可以阻止跳授权
   * @param {Function} opt.onError 失败回调
   * @param {String} opt.isNotInWechat 微信场景获取授权还是移动浏览器场景获取授权
   * @param {String} opt.redirectUrl 指定授权回调地址
   * @param 登录态需要传进来
   */
  getRealInfo: function (opt) {
    opt = opt || {}
    if (this.type === TYPE.NEED_OAUTH) {
      return false
    }

    let that = this

    if (!opt.sync) {
      //非同步模式下去请求cgi
      let param = {
        from_https: 1,
        from_h5: 1,
        pf: "mds_wechat_qb-pay_html5-iap",
        pfkey: "pfkey",
        action: "real_name_query",
        wx_pay_scope: "pay_realname",
        wx_pay_code: this.type === TYPE.CODE ? this._code : "",
        wx_pay_refresh_token: this.type === TYPE.MY_REFRESH_TOKEN ? this._refresh_token : "",
        openid: opt.openid,
        openkey: opt.openkey,
        session_id: opt.session_id,
        session_type: opt.session_type,
        wx_appid: opt.wx_appid,
        r: Math.random()
      }
      let env = helper.getCgiEnv(opt.sandbox)
      //请求cgi
      request
        .ajax({
          url: `//${env}api.unipay.qq.com/v1/r/${opt.offerId}/apple_store_recharge_card`,
          data: param
        })
        .then(
          response => {
            handler(response)
          },
          () => {
            opt.onError &&
              opt.onError.call(that, {
                ret: 2
              })
          }
        )
    } else {
      throw new Error("We need get_wechat_userinfo response!")
    }

    function handler(response) {
      var res = response
      if (res) {
        //请求成功
        if (!~~res.ret && res.info) {
          var userInfo = res.info
          that.accessToken = decodeURIComponent(userInfo.access_token)
          that.realname = userInfo.real_name
          that.credential_id = userInfo.credential_id

          //缓存的refresh_token要看是否和当前要求scope匹配，如果不匹配、这个时候应该重新让用户授权,不能继续使用此access_token
          // if (that.type === TYPE.MY_REFRESH_TOKEN) {
          //   opt.onSuccess && opt.onSuccess.call(that)
          //   return
          // }

          //CODE模式保存refresh_token到cookie
          if (that.type === TYPE.CODE) {
            //将refresh_token存入cookie,10年有效期
            cookies.set(that.refreshTokenKey, decodeURIComponent(userInfo.refresh_token) || "", {})
          }
          opt.onSuccess && opt.onSuccess.call(that)
        } else if (~~res.ret === 2896) {
          //过期
          //如果是缓存的refresh_token。需要删掉他，避免下次进来还用到他
          if (that.type === TYPE.MY_REFRESH_TOKEN) {
            that.delRefreshToken()
          }

          if (opt.onExpire && opt.onExpire.call(that) === false) {
            /* eslint no-empty:"off"*/
          } else {
            that.oAuth(opt)
          }
        } else if (~~res.ret === 12273) {
          //获取用户信息失败

          if (that.type === TYPE.MY_REFRESH_TOKEN) {
            that.delRefreshToken()
            //如果缓存的refresh_token获取用户信息失败了，去跳授权
            that.oAuth(opt)
          } else {
            opt.onError && opt.onError.call(that, res)
          }
          //授权拿到的code不是snsapi_useinfo，给他重新跳授权也没用
        } else {
          that.delRefreshToken()
          opt.onError && opt.onError.call(that, res)
        }
      } else {
        opt.onError && opt.onError.call(that)
      }
    }
  },
  delRefreshToken: function () {
    cookies.set(this.refreshTokenKey, "", { time: -3600 })
  },
  /**
   * 跳授权
   */
  oAuth: function (opt) {
    let url =
      "//payapp.weixin.qq.com/appauth/authindex?" +
      "appid=" +
      this.appid +
      "&mch_id=" +
      this.mchid +
      "&redirect_uri=" +
      encodeURIComponent(urlHandler.delParam(["code", "state"], opt.redirectUrl || location.href)) +
      "&response_type=code" +
      "&scope=" +
      this.scope +
      "&state=" +
      this.context +
      "#wechat_redirect"

    location.href = url
  }
}

export default wechat
